import React from 'react'
import axios from "axios";

import { useState } from 'react'

import cont_icon from "../../Components/Images/contact.png"

import icon1 from '../Images/newicon (8).png'
import icon2 from '../Images/newicon (6).png'
import icon3 from '../Images/newicon (2).png'
import icon4 from '../Images/newicon (4).png'
import config from '../../config/config';

const Popupform = () => {
    // for validation 
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        city: '',
        course: '',
    });

    const [errors, setErrors] = useState({
        name: '',
        phone: '',
        city: '',
    });

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Validate before submission
        const newErrors = {};
        if (!formData.name || !/^[a-zA-Z\s]+$/.test(formData.name)) {
            newErrors.name = "Please enter a valid name";
        }
        if (!formData.phone || !/^\d{10}$/.test(formData.phone)) {
            newErrors.phone = "Please enter a valid 10-digit phone number";
        }
        if (!formData.city || !/^[a-zA-Z\s]+$/.test(formData.city)) {
            newErrors.city = "Please enter a valid city";
        }
        if (!formData.email || !/^\S+@\S+\.\S+$/.test(formData.email)) {
            newErrors.email = "Please enter a valid email address";
        }


        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            console.log(newErrors, "newErrors");
            return; // Stop submission
        }

        const course = e.target.course.value;
        const email = formData.email;
        const terms = e.target.terms.checked;

        const dataToSend = {
            ...formData,
            email,
            course,
            terms,
        };

        try {
            const response = await axios.post(
                `${config.API_BASE_URL}/api/user/lead_data`,
                dataToSend,
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );

            if (response.status === 201 || response.status === 200) {
                alert("Form submitted successfully!");
                setFormData({ name: '', email: '', phone: '', city: '', course: '' });
            } else {
                alert("Submission failed: " + response.data.message);
            }
        } catch (error) {
            console.error("Error submitting form:", error);
            alert("Error submitting form.");
        }
    };




    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name === 'name' || name === 'city') {
            if (/^[a-zA-Z\s]*$/.test(value)) {
                setFormData({ ...formData, [name]: value });
                setErrors({ ...errors, [name]: '' });
            } else {
                setErrors({ ...errors, [name]: 'You can type only characters' });
            }
        } else if (name === 'phone') {
            if (/^\d{0,10}$/.test(value)) {
                setFormData({ ...formData, phone: value });
                setErrors({ ...errors, phone: '' });
            } else {
                setErrors({ ...errors, phone: 'Only numbers are allowed' });
            }
        } else {
            setFormData({ ...formData, [name]: value });
        }
    };

    return (
        <>
            {/* Gradient Header with Icon */}
            <div className="relative bg-gradient-to-r from-orange-500 to-orange-600 text-white px-8 py-10 rounded-t-2xl -mx-8 -mt-8 mb-8">
                <div className="absolute top-6 right-6 bg-white/20 backdrop-blur-sm rounded-full p-3">
                    <svg className="w-8 h-8" fill="currentColor" viewBox="0 0 20 20">
                        <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                        <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                    </svg>
                </div>
                <h2 className="text-3xl font-bold mb-2">Need Counselling?</h2>
                <p className="text-orange-100 text-sm">Fill out the form and our team will get back to you within 24 hours.</p>
            </div>

            {/* Form */}
            <form onSubmit={handleSubmit}>
                {/* Row 1: Name & Email */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                    <div className="form-group">
                        <div className="relative">
                            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                <svg className="h-5 w-5 text-gray-400" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" stroke="currentColor">
                                    <path d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                                </svg>
                            </div>
                            <input
                                required
                                autoComplete="off"
                                type="text"
                                name="name"
                                id="name"
                                value={formData.name}
                                onChange={handleChange}
                                className="w-full pl-10 pr-4 py-3 border-2 border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-400 focus:border-transparent text-sm transition-all duration-200 hover:border-gray-300"
                                placeholder="Full Name"
                            />
                        </div>
                        {errors.name && <span className="text-xs text-red-500 mt-1 block flex items-center gap-1">
                            <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                                <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                            </svg>
                            {errors.name}
                        </span>}
                    </div>

                    <div className="form-group">
                        <div className="relative">
                            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                <svg className="h-5 w-5 text-gray-400" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" stroke="currentColor">
                                    <path d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                                </svg>
                            </div>
                            <input
                                required
                                autoComplete="off"
                                type="email"
                                name="email"
                                id="email"
                                value={formData.email}
                                onChange={handleChange}
                                className="w-full pl-10 pr-4 py-3 border-2 border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-400 focus:border-transparent text-sm transition-all duration-200 hover:border-gray-300"
                                placeholder="Email"
                            />
                        </div>
                        {errors.email && <span className="text-xs text-red-500 mt-1 block flex items-center gap-1">
                            <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                                <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                            </svg>
                            {errors.email}
                        </span>}
                    </div>
                </div>

                {/* Row 2: Phone & City */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                    <div className="form-group">
                        <div className="relative">
                            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                <svg className="h-5 w-5 text-gray-400" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" stroke="currentColor">
                                    <path d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                                </svg>
                            </div>
                            <input
                                required
                                autoComplete="off"
                                type="text"
                                name="phone"
                                id="phone"
                                value={formData.phone}
                                onChange={handleChange}
                                className="w-full pl-10 pr-4 py-3 border-2 border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-400 focus:border-transparent text-sm transition-all duration-200 hover:border-gray-300"
                                placeholder="Phone"
                            />
                        </div>
                        {errors.phone && <span className="text-xs text-red-500 mt-1 block flex items-center gap-1">
                            <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                                <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                            </svg>
                            {errors.phone}
                        </span>}
                    </div>

                    <div className="form-group">
                        <div className="relative">
                            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                <svg className="h-5 w-5 text-gray-400" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" stroke="currentColor">
                                    <path d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                                    <path d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                                </svg>
                            </div>
                            <input
                                required
                                autoComplete="off"
                                type="text"
                                name="city"
                                id="city"
                                value={formData.city}
                                onChange={handleChange}
                                className="w-full pl-10 pr-4 py-3 border-2 border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-400 focus:border-transparent text-sm transition-all duration-200 hover:border-gray-300"
                                placeholder="City"
                            />
                        </div>
                        {errors.city && <span className="text-xs text-red-500 mt-1 block flex items-center gap-1">
                            <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                                <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                            </svg>
                            {errors.city}
                        </span>}
                    </div>
                </div>

                {/* Course Dropdown */}
                <div className="mb-5">
                    <div className="relative">
                        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                            <svg className="h-5 w-5 text-gray-400" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" stroke="currentColor">
                                <path d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
                            </svg>
                        </div>
                        <select
                            required
                            name="course"
                            id="course"
                            value={formData.course}
                            onChange={handleChange}
                            className="w-full pl-10 pr-4 py-3 border-2 border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-400 focus:border-transparent text-gray-700 text-sm appearance-none bg-white transition-all duration-200 hover:border-gray-300"
                        >
                            <option value="">Select Course</option>
                            <option value="btech">B.Tech</option>
                            <option value="mtech">M.Tech</option>
                            <option value="mba">MBA</option>
                            <option value="bca">BCA</option>
                            <option value="msc">M.Sc</option>
                            <option value="ma">MA</option>
                            <option value="phd">PhD</option>
                            <option value="bba">BBA</option>
                            <option value="mca">MCA</option>
                            <option value="bsc">B.Sc</option>
                            <option value="ba">BA</option>
                            <option value="bcom">B.Com</option>
                            <option value="mcom">M.Com</option>
                            <option value="bds">BDS</option>
                            <option value="mbbs">MBBS</option>
                            <option value="law">LLB</option>
                            <option value="bfa">BFA</option>
                            <option value="mfa">MFA</option>
                        </select>
                        <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                            <svg className="h-5 w-5 text-gray-400" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" stroke="currentColor">
                                <path d="M19 9l-7 7-7-7" />
                            </svg>
                        </div>
                    </div>
                </div>

                {/* Terms Checkbox */}
                <div className="flex items-start mb-6 bg-orange-50 border border-orange-100 p-3 rounded-lg">
                    <input
                        type="checkbox"
                        name="terms"
                        id="termsCheckbox"
                        className="mt-1 mr-2 w-4 h-4 text-orange-600 border-gray-300 rounded focus:ring-orange-500 flex-shrink-0"
                    />
                    <label htmlFor="termsCheckbox" className="text-xs text-gray-700">
                        By submitting this form, you accept and agree to our{' '}
                        <a href="/terms&condition" className="text-orange-600 hover:text-orange-700 font-medium underline">
                            Terms of Use
                        </a>
                        .
                    </label>
                </div>

                {/* Submit Button */}
                <button
                    type="submit"
                    className="w-full bg-gradient-to-r from-orange-500 to-orange-600 text-white py-4 px-6 rounded-lg font-bold text-lg hover:from-orange-600 hover:to-orange-700 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 flex items-center justify-center gap-2"
                >
                    Submit Application
                    <svg className="w-5 h-5" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" stroke="currentColor">
                        <path d="M13 7l5 5m0 0l-5 5m5-5H6" />
                    </svg>
                </button>

                {/* Trust Badge */}
                <p className="text-center text-xs text-gray-500 mt-4 flex items-center justify-center gap-1">
                    <svg className="w-4 h-4 text-green-500" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M2.166 4.999A11.954 11.954 0 0010 1.944 11.954 11.954 0 0017.834 5c.11.65.166 1.32.166 2.001 0 5.225-3.34 9.67-8 11.317C5.34 16.67 2 12.225 2 7c0-.682.057-1.35.166-2.001zm11.541 3.708a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                    </svg>
                    Your information is secure and confidential
                </p>
            </form>
        </>
    )
}

export default Popupform
